import React from 'react';
import classNames from 'classnames';
import Card from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Card';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import TextField from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/TextField';

const styles = (theme) => ({
  root: {
  },
  card: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.facet.accentGreen,
    cursor: 'pointer',
    right: 0,
    position: 'absolute',
  },
});

const AddHousehold = ({
  className,
  classes,
  onChange,
  resource,
}) => {
  const householdRecipientOptions = resource.meta().field('addedRecipients').options().list()
    .map((recipientResource) => ({
      name: recipientResource.attr('prompt'),
      value: recipientResource.id(),
    }));

  return (
    <div className={classNames(classes.root, className)}>
      <Card className={classes.card}>
        <MuiAutocomplete
          style={{ width: 300 }}
          onChange={(event, val) => {
            onChange(resource.meta().field('addedRecipients').options().list()
              .find(v => v.id() === val?.value));
          }}
          getOptionSelected={(option, value) => option.name === value.name}
          getOptionLabel={(option) => option.name}
          options={householdRecipientOptions}
          noOptionsText={'No households'}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Add Manually"
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
      </Card>
    </div>
  );
};

AddHousehold.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  resource: PropTypes.func.isRequired,
};

AddHousehold.defaultProps = {
  className: '',
};

export default withStyles(styles)(AddHousehold);
